import React, { useEffect } from 'react';
import { Menu, MenuItem, Icon, Table, Input } from 'semantic-ui-react';
import classNames from 'classnames';
import { useField } from '../../hooks';
import api from '../../api';
import Config from '../../constants/Config';
import styles from './SettlementDetails.module.scss';
import moment from 'moment';

const settlementManage = React.memo(() => {
  const [value, handleFieldChange] = useField('');
  const again = () => {
    setCurrrentSkip(1);
    setListObj({ list: [], total: 0 });
    init();
  };
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      again();
    }
  };
  const [sortable, setSortable] = React.useState({
    column: null,
    direction: null,
  });
  const [currentSkip, setCurrrentSkip] = React.useState(1);
  const [listObj, setListObj] = React.useState({
    list: [],
    total: 0,
  });

  const init = React.useCallback(() => {
    api
      .getSettlementDetailsLists({
        limit: Config.AONNOUCEMENT_LIMIT,
        skip: currentSkip - 1,
        sortable: sortable.column
          ? `${sortable.column} ${sortable.direction === 'ascending' ? 'asc' : 'desc'}`
          : '',
        search: value,
      })
      .then((res) => {
        setListObj({ list: res.item, total: res.total });
      });
  }, [currentSkip, sortable, value]);

  useEffect(() => {
    init();
  }, [currentSkip, sortable]);
  return (
    <div className={styles.app}>
      <div className={styles.table}>
        <div className={styles.box}>
          <Input
            value={value}
            onChange={handleFieldChange}
            action={{
              content: '搜索',
              onClick: again,
            }}
            onKeyPress={handleKeyPress}
            placeholder="姓名/推广码"
          />
        </div>
        <Table celled unstackable fixed sortable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={2}>姓名</Table.HeaderCell>
              <Table.HeaderCell width={2}>推广码</Table.HeaderCell>
              <Table.HeaderCell
                sorted={sortable.column === 'amount' ? sortable.direction : null}
                width={2}
                onClick={() => {
                  let direction = 'ascending';
                  if (sortable.column === 'amount') {
                    direction = sortable.direction === 'ascending' ? 'descending' : 'ascending';
                  }
                  setSortable({
                    column: 'amount',
                    direction,
                  });
                }}
              >
                结算金额（¥）
                {sortable.column !== 'amount' && <Icon name="sort" />}
              </Table.HeaderCell>
              <Table.HeaderCell width={2}>附件</Table.HeaderCell>
              <Table.HeaderCell
                sorted={sortable.column === 'createdAt' ? sortable.direction : null}
                width={2}
                onClick={() => {
                  let direction = 'ascending';
                  if (sortable.column === 'createdAt') {
                    direction = sortable.direction === 'ascending' ? 'descending' : 'ascending';
                  }
                  setSortable({
                    column: 'createdAt',
                    direction,
                  });
                }}
              >
                创建日期
                {sortable.column !== 'createdAt' && <Icon name="sort" />}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {!!listObj.list.length &&
              listObj.list.map((item) => (
                <Table.Row key={item.id}>
                  <Table.Cell>{item.user.name}</Table.Cell>
                  <Table.Cell>{item.user.promotionCode}</Table.Cell>
                  <Table.Cell>{item.amount}</Table.Cell>
                  <Table.Cell>
                    <a href={item.url} download target="_blank" rel="noreferrer">
                      {item.name}
                    </a>
                  </Table.Cell>
                  <Table.Cell>
                    {item.createdAt && moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="5">
                <Menu floated="right" pagination>
                  <MenuItem
                    as="a"
                    icon
                    onClick={() => {
                      setCurrrentSkip((pre) => {
                        if (pre <= 1) {
                          return 1;
                        }
                        return pre - 1;
                      });
                    }}
                  >
                    <Icon name="chevron left" />
                  </MenuItem>
                  {Array.from({ length: listObj.total }, (_, index) => (
                    <MenuItem
                      as="a"
                      key={index}
                      className={classNames(index + 1 === currentSkip && styles.menuItemActive)}
                      onClick={() => {
                        setCurrrentSkip(index + 1);
                      }}
                    >
                      {index + 1}
                    </MenuItem>
                  ))}
                  <MenuItem
                    as="a"
                    icon
                    onClick={() => {
                      setCurrrentSkip((pre) => {
                        if (pre + 1 >= listObj.total) {
                          return listObj.total;
                        }
                        return pre + 1;
                      });
                    }}
                  >
                    <Icon name="chevron right" />
                  </MenuItem>
                </Menu>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    </div>
  );
});

export default settlementManage;
